import styled from '@emotion/styled';

import { customPalette } from '../../../styles/theme';

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 20px);
  text-align: center;
  background-color: ${customPalette.grey[100]};
  color: ${customPalette.grey.main};
  font-family: Arial, sans-serif;
`;

export const ErrorTitle = styled.h1`
  font-size: 2rem;
  margin: 100px 0 40px 0;
`;

export const ErrorMessage = styled.p`
  margin-bottom: 100px;
`;
